import { GlobalState } from "../global.store";

export const selectCategories = (state: GlobalState) => {
  return state.categories;
};
